import React from "react"

const CaratDown = props => (
  <svg viewBox="0 0 28 28" {...props}>
    <path d="M27.404 6.547a1.728 1.728 0 00-2.365.199L14 17.551 2.964 6.746a1.725 1.725 0 00-2.369-.199 1.68 1.68 0 00-.2 2.366l12.32 12.32a1.68 1.68 0 002.566 0l12.32-12.32a1.684 1.684 0 00-.197-2.366z" />
  </svg>
)

export default CaratDown
